import { createAction } from '../utils';
import * as actionTypes from './feedback.actionTypes';

export const getFeedback = () =>
  createAction(actionTypes.GET_FEEDBACK.REQUEST, {});
